import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Input } from '../../shared';

/** Strips letters and symbols; keeps digits and common phone formatting. */
const sanitizePhoneInput = (value) =>
  String(value ?? '').replace(/[^\d+()\s.-]/g, '');

const ContactInfoForm = ({
  bookingData,
  errors,
  onInputChange,
  user
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-6 sm:mb-8">
        <h2 className="text-xl sm:text-2xl font-bold text-black">
          Contact Information
        </h2>
        {user && (
          <div className="flex items-center text-sm text-black bg-gray-100 border border-black px-3 py-1.5 rounded-full">
            <CheckCircle className="w-4 h-4 mr-1.5" />
            Auto-filled
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-semibold text-black mb-2">
            First Name *
          </label>
          <Input
            type="text"
            value={bookingData.contactInfo.firstName}
            onChange={(e) => onInputChange('contactInfo.firstName', e.target.value)}
            placeholder="Enter your first name"
            className={`w-full ${errors['contactInfo.firstName'] ? 'border-red-500' : ''}`}
          />
          {errors['contactInfo.firstName'] && (
            <p className="mt-1 text-sm text-red-600">
              {errors['contactInfo.firstName']}
            </p>
          )}
        </div>
        <div>
          <label className="block text-sm font-semibold text-black mb-2">
            Last Name *
          </label>
          <Input
            type="text"
            value={bookingData.contactInfo.lastName}
            onChange={(e) => onInputChange('contactInfo.lastName', e.target.value)}
            placeholder="Enter your last name"
            className={`w-full ${errors['contactInfo.lastName'] ? 'border-red-500' : ''}`}
          />
          {errors['contactInfo.lastName'] && (
            <p className="mt-1 text-sm text-red-600">
              {errors['contactInfo.lastName']}
            </p>
          )}
        </div>
        <div>
          <label className="block text-sm font-semibold text-black mb-2">
            Email *
          </label>
          <Input
            type="email"
            value={bookingData.contactInfo.email}
            onChange={(e) => onInputChange('contactInfo.email', e.target.value)}
            placeholder="Enter your email"
            className={`w-full ${errors['contactInfo.email'] ? 'border-red-500' : ''}`}
          />
          {errors['contactInfo.email'] && (
            <p className="mt-1 text-sm text-red-600">
              {errors['contactInfo.email']}
            </p>
          )}
        </div>
        <div>
          <label className="block text-sm font-semibold text-black mb-2">
            Phone *
          </label>
          <Input
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            value={bookingData.contactInfo.phone}
            onChange={(e) =>
              onInputChange('contactInfo.phone', sanitizePhoneInput(e.target.value))
            }
            placeholder="Enter your phone number"
            className={`w-full ${errors['contactInfo.phone'] ? 'border-red-500' : ''}`}
          />
          {errors['contactInfo.phone'] && (
            <p className="mt-1 text-sm text-red-600">
              {errors['contactInfo.phone']}
            </p>
          )}
        </div>
      </div>
      {user && (
        <div className="mt-6 p-4 bg-gray-100 border border-gray-300 rounded-lg">
          <p className="text-sm text-black">
            <strong>Note:</strong> Your contact information has been automatically
            filled from your profile. You can edit any field if needed.
          </p>
        </div>
      )}
    </div>
  );
};

export default ContactInfoForm;

